module.exports = __webpack_public_path__ + "static/media/portfolio1 (33).d8cd6c5e.jpeg";